import { loadInterceptors, initRequest } from "sdsn-front-init";
import { ElMessage } from "element-plus";

import { useUserStore } from "@/store/user";
import { exportFile } from "@/utils/utils";

const responseConfig = {
  // 响应
  onFulfilled(config: any) {
    if (Object.prototype.toString.call(config.data) === "[object Blob]") {
      if (config.data.type === "application/json") {
        const reader = new FileReader();
        reader.onload = function (event) {
          try {
            const result = JSON.parse(event!.target!.result as string); // 将字符串解析为 JSON
            if (result.code !== 0) {
              ElMessage.error(result.msg);
            }
          } catch (error) {
            console.error("解析 JSON 失败:", error);
          }
        };
        reader.readAsText(config.data); // 将 Blob 转换为字符串
        //
      } else {
        exportFile(config.data, extractFilename(window.decodeURIComponent(config.headers["content-disposition"])) as string);
        return {
          code: 200,
          data: "",
          msg: "ok!"
        };
      }
    } else {
      if (config.status === 200 && config.data.code === 0) {
        return config.data;
      } else if (config.status === 401 || config.data.code === 401) {
        // mainApi.loginOut();
        return config.data;
      } else if (config.status === 200 && config.data.code === 200) {
        return config.data;
      } else {
        if (config && !config.data.code) {
          return config.data;
        } else {
          ElMessage.error(config.data.msg);
          return config.data;
        }
      }
    }
  },
  onRejected(config: any) {
    ElMessage({
      message: config.response.data.msg || config.response.data.message,
      type: "error",
      duration: 5 * 1000
    });
    if (config.response.status === 401 || config.response.data.code === 401) {
      localStorage.removeItem("token");
      // 跳转登录页
      import("@/router/index").then((module) => {
        const router = module.default;
        if (router.currentRoute.value.name !== "Login") {
          router.push({ name: "Login" });
        }
      });
    }

    return config.response.data;
  }
};
const requestConfig = {
  // 请求配置
  onFulfilled(config: any) {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["token"] = token;
    }
    return config;
  }
};
export function initAxios() {
  initRequest("/", { timeout: 10 * 60 * 1000 });
  loadInterceptors({ response: [responseConfig], request: [requestConfig] });
}

function extractFilename(contentDisposition: any) {
  // 定义正则表达式，匹配 filename 部分
  const regex = /filename=["']?([^"']+)["']?/;

  // 使用正则表达式匹配字符串
  const match = regex.exec(contentDisposition);

  // 如果匹配到结果，返回 filename 的值，否则返回 null
  return match ? match[1] : null;
}
